import { render, staticRenderFns } from "./VideoOverlay.vue?vue&type=template&id=c6f9a8ec&"
import script from "./VideoOverlay.vue?vue&type=script&lang=js&"
export * from "./VideoOverlay.vue?vue&type=script&lang=js&"
import style0 from "./VideoOverlay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports